import { Injectable } from "@angular/core";
import { CalcolaDimensioniRequestDTO } from "../dto/calcola-dimensioni-requestDTO";
import { CalcolaDimensioniRequestVO } from "../vo/calcola-dimensioni-requestVO";
import { MapperInterface } from "./mapper-inteface";

@Injectable({
  providedIn: "root",
})
export class MapperCalcolaDimensioniRequest
  implements
    MapperInterface<CalcolaDimensioniRequestDTO, CalcolaDimensioniRequestVO> {
  convertVoToDto(t: CalcolaDimensioniRequestVO): CalcolaDimensioniRequestDTO {
    const calcolaDimemsioniRequestDTO: CalcolaDimensioniRequestDTO = new CalcolaDimensioniRequestDTO();
    calcolaDimemsioniRequestDTO.idDocuments = t.idDocuments;
    calcolaDimemsioniRequestDTO.sizeLimit = t.sizeLimit;
    return calcolaDimemsioniRequestDTO || new CalcolaDimensioniRequestDTO();
  }
  convertDtoToVo(t: CalcolaDimensioniRequestDTO): CalcolaDimensioniRequestVO {
    const calcolaDimemsioniRequestVO: CalcolaDimensioniRequestVO = new CalcolaDimensioniRequestVO();
    calcolaDimemsioniRequestVO.idDocuments = t.idDocuments;
    calcolaDimemsioniRequestVO.sizeLimit = t.sizeLimit;
    return calcolaDimemsioniRequestVO || new CalcolaDimensioniRequestVO();
  }
  convertListVoToDto(
    e: CalcolaDimensioniRequestVO[]
  ): CalcolaDimensioniRequestDTO[] {
    throw new Error("Method not implemented.");
  }
  convertListDtoToVo(
    t: CalcolaDimensioniRequestDTO[]
  ): CalcolaDimensioniRequestVO[] {
    throw new Error("Method not implemented.");
  }
}
